export const paymentTabs = ['pricing', 'invoices', 'top-up', 'credit-history'] as const;

export type PaymentTab = (typeof paymentTabs)[number];
